<template>
    <v-row
        v-if="item"
        justify="center"
        align="center"
        class="ml-2 mr-2 pb-1 user-collections-item"
        dense
        :style="index % 2 === 0 ? 'background-color: #222420' : 'background-color: #3c3c3c'"
    >
        <!-- picture -->
        <v-col
            xl="1"
            lg="1"
            md="1"
            sm="2"
            cols="2"
            class="user"
        >
            <listing-picture
                v-if="picture"
                :picture="picture"
                :alt="name"
                size="sm"
                direction="front"
            ></listing-picture>
        </v-col>
        <!-- info -->
        <v-col
            xl="8"
            lg="8"
            md="8"
            sm="6"
            cols="10"
        >
            <v-card-text class="pa-0"
            >
                <div class="vs-link name item-width" @click="$emit('clicked', item)">
                    <template v-if="item.parent">
                        <v-icon v-if="item.parent.public_view" color="green" small>mdi-earth</v-icon>
                        <v-icon v-if="!item.parent.public_view" color="red" small>mdi-lock</v-icon>
                        <v-icon v-if="item.parent.default && item.parent.style == '2'" small>mdi-eye</v-icon>
                        <v-icon v-if="item.parent.default && item.parent.style == '6'" small>mdi-eye-plus</v-icon>
                        <v-icon v-if="item.parent.default && item.parent.style == '3'" small>mdi-flag</v-icon>
                        <v-icon v-if="item.parent.default && item.parent.style == '4'" small>mdi-flag-plus</v-icon>
                        <v-icon v-if="item.parent.default && item.parent.style == '5'" small>mdi-currency-usd</v-icon>
                    </template>
                    <template v-if="!item.parent">
                        <v-icon v-if="item.public_view" color="green" small>mdi-earth</v-icon>
                        <v-icon v-if="!item.public_view" color="red" small>mdi-lock</v-icon>
                        <v-icon v-if="item.default && item.style == '2'" small>mdi-eye</v-icon>
                        <v-icon v-if="item.default && item.style == '6'" small>mdi-eye-plus</v-icon>
                        <v-icon v-if="item.default && item.style == '3'" small>mdi-flag</v-icon>
                        <v-icon v-if="item.default && item.style == '4'" small>mdi-flag-plus</v-icon>
                        <v-icon v-if="item.default && item.style == '5'" small>mdi-currency-usd</v-icon>
                    </template>
                    <template v-if="!item.public_id">
                        {{ $t('collection name') }}: {{ name }}
                    </template>
                    <template v-else>
                        {{ name }}
                        <template v-if="item.format">
                            [{{ item.format.name }}]
                        </template>
                    </template>
                </div>
                <div v-if="item.model == 'collection'">

                    <template v-if="item.mode == 1">{{ $t('movies') }}</template>
                    <template v-if="item.mode == 2">{{ $t('releases') }}</template>
                    {{ $t('collection') }},
                    <template v-if="item.style == 1">{{ $t('no definition') }}</template>
                    <template v-if="item.style == 2">{{ $t('have seen') }}</template>
                    <template v-if="item.style == 6">{{ $t('want see') }}</template>
                    <template v-if="item.style == 3">{{ $t('have it') }}</template>
                    <template v-if="item.style == 4">{{ $t('you want it') }}</template>
                    <template v-if="item.style == 5">{{ $t('for sale') }}</template>
                </div>
                <div v-if="model == 'collection'" class="name item-width">
                    {{ item.short_description }}
                </div>

                <v-slide-group class="item-width">
                    <v-chip class="mr-1" small v-if="item.rating" :title="$t('rating')" outlined>
                        <v-rating
                            length="5"
                            :half-increments="true"
                            color="yellow"
                            background-color="grey"
                            readonly
                            dense
                            small
                            :value="item.rating / 2"

                        ></v-rating>
                    </v-chip>

                    <v-chip v-if="item.entries_count" small>
                        {{ $t('entries') }}: {{ item.entries_count }}
                    </v-chip>

                    <v-chip class="mr-1" small v-if="item.price" :title="item.price" outlined >
                        {{ $t('price') }}: {{ item.price / 100 }} {{ item.price_currency }}
                    </v-chip>

                    <v-chip class="mr-1" small v-if="item.condition" :title="item.condition" outlined>
                        {{ $t('condition') }}: {{ $t('condition '+item.condition) }}
                    </v-chip>

                    <v-chip class="mr-1" small v-if="item.source" :title="item.source" outlined>
                        {{ $t('watched on') }}: {{ item.source }}
                    </v-chip>

                    <v-chip small v-if="item.userdate" :title="item.userdate" outlined>
                        {{ $t('date') }}: {{ $day(item.userdate).format('DD/MM/YYYY') }}
                    </v-chip>

                </v-slide-group>
            </v-card-text>
        </v-col>
        <v-col
            xl="3"
            lg="3"
            md="3"
            sm="4"
            cols="12"
            v-if="!selected" class="text-center">
            <v-btn
                class="v-positive-button ma-2"
                v-if="go && item.public_id"
                @click="$emit('clicked', item)"
                small
            >
                <v-icon x-small>mdi-check</v-icon>
                {{ $t('select') }}
            </v-btn>
            <v-btn
                v-if="!item.public_id"
                class="v-positive-button ma-2"
                @click="$emit('clicked', item)"
                small
            >
                <v-icon x-small>mdi-pencil-plus-outline</v-icon>
                {{ $t('edit') }}
            </v-btn>
            <v-btn
                v-if="!item.public_id"
                class="red ma-2"
                small
                @click="$emit('delete', item)"
            >
                <v-icon x-small>mdi-delete-forever</v-icon>
                {{ $t('delete') }}
            </v-btn>
            <div>
            <router-link
                class="ma-2"
                :to="'/collection/'+item.parent.public_id"
                v-if="go && item.parent?.public_id"
            >
                {{ $t('go to') }} {{ $t('collection') }}
                <v-icon x-small>mdi-arrow-right</v-icon>
            </router-link>
            <router-link
                class="ma-2"
                :to="'/collection/'+item.public_id"
                v-if="go && item.public_id"
            >
                {{ $t('go to') }} {{ $t('collection') }}
                <v-icon x-small>mdi-arrow-right</v-icon>
            </router-link>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import ListingPicture from "@/components/listings/ListingPicture";
export default {
    name: "UserCollectionsItem",
    components: {
        ListingPicture
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        index: Number,
        selected: Boolean,
        go: Boolean,
    },
    computed: {
        name(){
            if(this.item.parent) return this.item.parent.name
                else
                    return this.item.name
        },
        model(){
            if(this.item.parent) return this.item.parent.model
            else
                return this.item.model
        },
        picture(){
            if(this.item.parent) return this.item.parent.picture
            else
                return this.item.picture
        },
    }
}
</script>

<style scoped>
.user-collections-item{
    min-height: 75px;
    border-radius: 5px;
    margin-bottom: 5px;
}
.name {
    text-overflow: ellipsis; /* enables ellipsis */
    white-space: nowrap; /* keeps the text in a single line */
    overflow: hidden; /* keeps the element from overflowing its parent */
}
.item-width {
    max-width: 600px;
}

@media (max-width: 767px) {
    .item-width {
        max-width: 250px;
    }
}
</style>
